module.exports = __webpack_public_path__ + "img/img21.cc8aa00b.jpg";